import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Home from 'material-ui/svg-icons/action/home';
import Flight from 'material-ui/svg-icons/maps/flight';
import People from 'material-ui/svg-icons/social/people';
import { Link } from 'react-router-dom';
import Vendor from 'material-ui/svg-icons/maps/hotel';
import TrendingUp from 'material-ui/svg-icons/action/trending-up';
import QuestionAnswer from 'material-ui/svg-icons/action/question-answer';
import Receipt from 'material-ui/svg-icons/action/receipt';
import { StyleSheet, css } from 'aphrodite';

import OurismanTravelTheme from '../../ourismanTravelTheme';

const NavBar = (props) => {
  const { version } = props;

  return (<div className={css(styleSheet.container)}>
    <Link to='/'>
      <div className={css(styleSheet.iconContainer)}>
        <Home className={css(styleSheet.icon)} />
        <span className={css(styleSheet.label)}>Home</span>
      </div>
    </Link>
    {/* <Link to='/tasks/'>
        <div className={css(styleSheet.iconContainer)}>
          <DoneAll className={css(styleSheet.icon)} />
          <span className={css(styleSheet.label)}>To Do</span>
        </div>
      </Link> */}
    <Link to='/trips/'>
      <div className={css(styleSheet.iconContainer)}>
        <Flight className={css(styleSheet.icon)} />
        <span className={css(styleSheet.label)}>Trips</span>
      </div>
    </Link>
    <Link to='/quote/'>
      <div className={css(styleSheet.iconContainer)}>
        <Receipt className={css(styleSheet.icon)} />
        <span className={css(styleSheet.label)}>Rate Quote</span>
      </div>
    </Link>
    <Link to='/clients/'>
      <div className={css(styleSheet.iconContainer)}>
        <People className={css(styleSheet.icon)} />
        <span className={css(styleSheet.label)}>Clients</span>
      </div>
    </Link>
    <Link to='/vendors/'>
      <div className={css(styleSheet.iconContainer)}>
        <Vendor className={css(styleSheet.icon)} />
        <span className={css(styleSheet.label)}>Vendors</span>
      </div>
    </Link>
    <Link to='/forms/responses/'>
      <div className={css(styleSheet.iconContainer)}>
        <QuestionAnswer className={css(styleSheet.icon)} />
        <span className={css(styleSheet.label)}>Form Responses</span>
      </div>
    </Link>
    <Link to='/reports/'>
      <div className={css(styleSheet.iconContainer)}>
        <TrendingUp className={css(styleSheet.icon)} />
        <span className={css(styleSheet.label)}>Reports</span>
      </div>
    </Link>
    <div className={css(styleSheet.version)}>Ping Pong v{version}</div>
  </div>);
};

NavBar.propTypes = {
  version: PropTypes.string.isRequired,
};


export default connect(state => ({ version: state.Auth.get('version') }))(NavBar);


const styleSheet = StyleSheet.create({
  container: {
    background: OurismanTravelTheme.palette.primary3Color,
    boxSizing: 'content-box',
    display: 'flex',
    position: 'fixed',
    '@media (max-width: 800px)': {
      borderTop: `2px solid ${OurismanTravelTheme.palette.borderColor}`,
      bottom: 0,
      justifyContent: 'space-around',
      paddingBottom: 5,
      paddingTop: 5,
      width: '100%',
      zIndex: 1000,
    },
    '@media (min-width: 800px)': {
      alignItems: 'center',
      borderRight: `2px solid ${OurismanTravelTheme.palette.borderColor}`,
      flexDirection: 'column',
      height: 'calc(100vh - 64px)',
      paddingRight: 10,
      top: 64,
      width: 70,
    },
  },
  icon: {
    width: 50,
    height: 50,
  },
  iconContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '@media (min-width: 800px)': {
      marginTop: 10,
      marginLeft: 10,
    },
  },
  label: {
    '@media (max-width: 800px)': {
      display: 'none',
    },
    '@media (min-width: 800px)': {
      textAlign: 'center',
      fontSize: 15,
      color: OurismanTravelTheme.palette.textColor,
    },
  },
  activeLinkStyle: {},
  version: {
    '@media (max-width: 800px)': {
      display: 'none',
    },
    '@media (min-width: 800px)': {
      fontSize: 9,
      fontWeight: 'bold',
      marginTop: 'auto',
    },
  },
});



// WEBPACK FOOTER //
// /src/components/Container/NavBar.js